import _ from "lodash";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useBalanceStore } from "../../_store/balanceStore";
import { useFuturePlanStore } from "../../_store/futurePlanStore";
import { useRetireStore } from "../../_store/retireStore";
import { HeaderTitle } from "../../components/header/Header";
import ClearDataButton from "../../components/button/ClearDataButton";
import Container from "../../components/layout/Container";
import {
  STYLE_BG_CIRCLE,
  STYLE_MARGIN_TOP_PARENT
} from "../../utils/useStyle";
import { numberWithoutComma } from "../balance/component/VIDrawerDebt.Main";
import { first_reload } from "../insuarance_plan/functions/firstLoad";
import FutureProfile from "./components/VIFutureProfile";
import FuturePlan from "./components/VIFuture_Plan";

const FutureMain = () => {
  const navigate = useNavigate();
  const retireData = useRetireStore((state) => state.retireData);
  const balanceData = useBalanceStore((state) => state.balanceData);
  const setFuturePlanData = useFuturePlanStore(
    (state) => state.setFuturePlanData
  );
  const futurePlanData = useFuturePlanStore((state) => state.futurePlanData);
  const clearFuturePlanData = useFuturePlanStore((state) => state.clearFuturePlanData);
  const [isPlan, setIsPlan] = useState(false);
  const [tab, setTab] = useState(0);

  useEffect(() => {

    setFuturePlanData({
      ...futurePlanData,
      age_current: retireData?.age_current,
      age_retire: retireData?.age_retire,
      age_dead: retireData?.age_dead,
      salary: retireData?.salary,
      salary_peryear_max: retireData?.salary_peryear_max,
      other_income: retireData?.other_income,
      other_income_growth: retireData?.other_income_peryear,
      other_income_growth_max: retireData?.other_income_peryear_max,
      salary_peryear_duration: retireData?.other_income_length,
      salary_peryear_duration_is_explicit:
        retireData?.other_income_length_is_explicit === true,
      out_come_stable: retireData?.out_come,
      out_come : retireData?.out_come_variable,
      out_come_peryear: retireData?.out_come_peryear,
      income_investment: retireData?.investment_assets,
      pension_peryear: retireData?.pension,
      income_investment_percent: retireData?.investment_bf_retirement,
    });

    let ignore = false;
    first_reload(ignore);
    return () => {
      ignore = true;
    };
  }, []);

  // console.log(retireData, "retireData");

  // การแก้ระยะเวลาที่ future profile ต้องมี marker เพื่อรักษาค่าหนึ่งปี
  // ที่ผู้ใช้ตั้งเองและแยกออกจาก legacy default
  const onChangeForm =
    (fleld, type = "number") =>
    (e) => {
      let value = e.target.value;
      if (type === "number") {
        value = numberWithoutComma(value);
      }

      if (_.isNaN(value)) {
        value = "";
      }

      setFuturePlanData({
        ...futurePlanData,
        [fleld]: value,
        ...(fleld === "salary_peryear_duration"
          ? { salary_peryear_duration_is_explicit: true }
          : {}),
      });
    };

  return (
    <Container
      style={{
        backgroundImage: `url(/images/circle_right.png)`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right top",
      }}
      className={` ${STYLE_BG_CIRCLE} `}
    >
      <div id="first_reload">
        <div className={`${STYLE_MARGIN_TOP_PARENT} mb-10 `}>
          <HeaderTitle
            title="วางแผนอนาคต"
            isGoback
            onClickGoBack={() => {
              if (isPlan && tab === 0) {
                setIsPlan(false);
              } else {
                setTab(0);
              }
            }}
            rightContent={<ClearDataButton planName="แผนอนาคต" onClear={() => { clearFuturePlanData(); window.location.reload(); }} />}
          />

          {!isPlan ? (
            <FutureProfile
              age_current={retireData?.age_current}
              age_retire={retireData?.age_retire}
              age_dead={retireData?.age_dead}
              salary={retireData?.salary}
              salary_peryear={retireData?.salary_peryear}
              out_come={retireData?.out_come}
              investment_assets={retireData?.investment_assets}
              debt_short_list={balanceData?.debt_short_list}
              debt_long_list={balanceData?.debt_long_list}
              onClick={() => {
                setIsPlan(true);
                setTab(0)
              }}
              onChangeForm={onChangeForm}
            />
          ) : (
            <FuturePlan
              isPlan={isPlan}
              setIsPlan={setIsPlan}
              setTab={setTab}
              tab={tab}
            />
          )}
        </div>
      </div>
    </Container>
  );
};

export default FutureMain;
